module.exports = __webpack_public_path__ + "b55f850c59e6ec55c06a172e170d7980.svg";